import { render, staticRenderFns } from "./report-generate-form-xelio.vue?vue&type=template&id=2f5c5c23&scoped=true"
import script from "./report-generate-form-xelio.vue?vue&type=script&lang=js"
export * from "./report-generate-form-xelio.vue?vue&type=script&lang=js"
import style0 from "./report-generate-form-xelio.vue?vue&type=style&index=0&id=2f5c5c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c5c23",
  null
  
)

export default component.exports